'use strict';
import $ from 'jquery';
require('webpack-jquery-ui/selectmenu');

$(document).ready(function () {
    $('.collection__single-filter-input').on('change', () => {
        setUrl(null);
    });

    $('#sort_by').selectmenu({
        position: {
            my: 'right top-1',
            at: 'right bottom',
            of: '.collection__sort-holder'
        },
        change: function () {
            setUrl(null);
        }
    });

    $('.collection__filter-active').click(function () {
        setUrl($(this).attr('data-filter'));
    });

    const header = $('.header');
    const filtersBtn = $('#filters-mobile-btn');
    const shopBtn = $('#header-shop-btn');
    const filters = $('#collections-menu');

    filtersBtn.click(() => {
        if (header.hasClass('header--active')) {
            shopBtn.removeClass('header__menu-link--active');
            filters.fadeOut();

            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);

            setTimeout(() => {
                header.removeClass('header--active');
                header.removeClass('header--small');
            }, 16);
        } else {
            shopBtn.addClass('header__menu-link--active');
            header.addClass('header--active');
            filters.fadeIn();

            const scrollY = window.pageYOffset || document.documentElement.scrollTop;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;

            if (header.height() * 2 < scrollY) header.addClass('header--small');
        }
    });
});

function setUrl (filter) {
    let query = buildQuery(filter);

    query += '?sort_by=' + $('#sort_by').val();

    const location = window.location.pathname.split('/');

    window.location.href = location[0] + '/' + location[1] + '/' + location[2] + '/' + query;
}

function buildQuery (filter) {
    let query = '';

    let collection = '.collection__filters-holder';

    if (window.innerWidth < 992) {
        collection += '-mobile';
    }

    $(`${collection} .collection__single-filter-input:checked`).each(function (idx) {
        let val = $(this).val();
        console.log(val, filter);
        if (val !== filter) {
            if (idx !== 0) {
                query += '+' + val;
            } else {
                query += val;
            }
        }
    });

    return query;
}
